var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashierMachineGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500.523 500.523",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C960"
    },
    d: "M467.262,240.262l4-2h-440l-27.6,176h0.4h494h0.4L467.262,240.262z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2eff46"
    },
    d: "M496.062,419.062c-1.6-7.2-9.2-12.8-16.8-12.8h-463.2c-7.6,0-13.2,5.6-14.4,12.8 c0,0.8,0.8,2,0.8,2.8v58.8c0,8.8,5.2,17.6,14,17.6h463.2c8.8,0,18.8-8.8,18.8-17.6v-58.8 C498.062,420.662,496.462,419.862,496.062,419.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2eff46"
    },
    d: "M470.062,139.062c0-8.8-9.6-12.8-18.4-12.8h-408.4c-8.8,0-13.2,4.4-13.2,12.8v99.2h440V139.062z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4EFEF"
    },
    d: "M170.062,182.262v-104h-84v104H170.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M254.062,78.262h164v-72h-164V78.262z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.062,
    y: 74.262,
    style: {
      fill: "#AEB1B4"
    },
    width: 32,
    height: 52
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ACD9EA"
    },
    points: "222.062,146.262 222.062,146.662 222.062,222.262 450.062,222.262 450.062,146.262 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C960"
    },
    d: "M310.062,449.862c0-8.8-7.2-15.6-15.6-15.6h-100.4c-8.8,0-15.6,7.2-15.6,15.6v4.4 c0,8.8,7.2,15.6,15.6,15.6h100.4c8.8,0,15.6-7.2,15.6-15.6V449.862L310.062,449.862z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.062,
    y: 22.262,
    style: {
      fill: "#CDEEF9"
    },
    width: 136,
    height: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.062,
    y: 274.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.062,
    y: 274.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.062,
    y: 278.262,
    style: {
      fill: "#EFDC81"
    },
    width: 16,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.062,
    y: 274.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.062,
    y: 278.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.062,
    y: 318.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.062,
    y: 314.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.062,
    y: 314.262,
    style: {
      fill: "#EFDC81"
    },
    width: 16,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.062,
    y: 318.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.062,
    y: 318.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.062,
    y: 274.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.062,
    y: 314.262,
    style: {
      fill: "#EFDC81"
    },
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.062,
    y: 278.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.062,
    y: 278.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.062,
    y: 314.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.062,
    y: 314.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.062,
    y: 358.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.062,
    y: 358.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.062,
    y: 274.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.062,
    y: 314.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.062,
    y: 358.262,
    style: {
      fill: "#F4EFEF"
    },
    width: 20,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.462,500.262h-460.4c-10.8,0-19.6-8.8-19.6-19.6v-60.4c0-10.8,8.8-19.6,19.6-19.6h460.4c10.8,0,19.6,8.8,19.6,19.6v60.4 C500.062,491.462,491.262,500.262,480.462,500.262z M19.662,408.262c-6.4,0-11.6,5.2-11.6,11.6v60.4c0,6.4,5.2,11.6,11.6,11.6h460.4 c6.4,0,11.6-5.2,11.6-11.6l0,0v-60.4c0-6.4-5.2-11.6-11.6-11.6H19.662z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496.062,418.662c-2,0-3.6-1.2-4-3.2l-28-170.8h-432l-24.4,168.4c-0.4,2-2.4,3.6-4.4,3.2s-3.6-2.4-3.2-4.4l24.8-171.6 c0.4-2,2-3.6,4-3.6h438.8c2,0,3.6,1.6,4,3.2l28.8,174.4c0.4,2-1.2,4.4-3.2,4.4C496.462,418.662,496.462,418.662,496.062,418.662z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.062,238.262c-2.4,0-4-1.6-4-4v-99.2c0-3.2,0.8-5.6,2.8-7.6c4-3.6,10.4-3.6,16.4-3.6c1.2,0,2.4,0,3.6,0h34.8 c2.4,0,4,1.6,4,4c0,2.4-1.6,4-4,4h-34.8c-1.2,0-2.8,0-4,0c-4,0-9.2-0.4-10.8,1.2c0,0-0.4,0.4-0.4,1.6v99.6 C32.062,236.662,30.462,238.262,28.062,238.262z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.062,238.262c-2.4,0-4-1.6-4-4v-99.2c0-2.4-0.4-3.2-0.4-3.2c-0.4,0-2.4,0-4,0c-1.2,0-2.4,0-4,0h-281.6c-2.4,0-4-1.6-4-4 c0-2.4,1.6-4,4-4h281.6c1.2,0,2.4,0,3.6,0c4,0,7.6-0.4,10,2.4c2.4,2.4,2.8,6,2.8,8.8v99.2 C472.062,236.662,470.462,238.262,468.062,238.262z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.062,188.262h-84c-2.4,0-4-1.6-4-4v-104c0-2.4,1.6-4,4-4h84c2.4,0,4,1.6,4,4v104 C172.062,186.662,170.462,188.262,168.062,188.262z M88.062,180.262h76v-96h-76V180.262z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M416.062,80.262h-164c-2.4,0-4-1.6-4-4v-72c0-2.4,1.6-4,4-4h164c2.4,0,4,1.6,4,4v72 C420.062,78.662,418.462,80.262,416.062,80.262z M256.062,72.262h156v-64h-156V72.262z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M348.062,132.262h-32c-2.4,0-4-1.6-4-4v-50c0-2.4,1.6-4,4-4s4,1.6,4,4v46h24v-46c0-2.4,1.6-4,4-4s4,1.6,4,4v50 C352.062,130.662,350.462,132.262,348.062,132.262z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.062,224.262h-228c-2.4,0-4-1.6-4-4v-76c0-2.4,1.6-4,4-4h190c2.4,0,4,1.6,4,4s-1.6,4-4,4h-186v68h220v-68h-6 c-2.4,0-4-1.6-4-4s1.6-4,4-4h10c2.4,0,4,1.6,4,4v76C452.062,222.662,450.462,224.262,448.062,224.262z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296.462,472.262h-100.4c-10.8,0-19.6-8.8-19.6-19.6v-4.4c0-10.8,8.8-19.6,19.6-19.6h100.4c10.8,0,19.6,8.8,19.6,19.6v4.4 C316.062,463.462,307.262,472.262,296.462,472.262z M195.662,436.262c-6.4,0-11.6,5.2-11.6,11.6v4.4c0,6.4,5.2,11.6,11.6,11.6h100.4 c6.4,0,11.6-5.2,11.6-11.6l0,0v-4.4c0-6.4-5.2-11.6-11.6-11.6H195.662z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.062,188.262h-112c-2.4,0-4-1.6-4-4s1.6-4,4-4h112c2.4,0,4,1.6,4,4S188.462,188.262,186.062,188.262z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.062,208.262h-112c-2.4,0-4-1.6-4-4s1.6-4,4-4h112c2.4,0,4,1.6,4,4S188.462,208.262,186.062,208.262z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.062,108.262h-24c-2.4,0-4-1.6-4-4s1.6-4,4-4h24c2.4,0,4,1.6,4,4S128.462,108.262,126.062,108.262z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.062,128.262h-24c-2.4,0-4-1.6-4-4s1.6-4,4-4h24c2.4,0,4,1.6,4,4S128.462,128.262,126.062,128.262z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.062,148.262h-24c-2.4,0-4-1.6-4-4s1.6-4,4-4h24c2.4,0,4,1.6,4,4S128.462,148.262,126.062,148.262z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.062,168.262h-24c-2.4,0-4-1.6-4-4s1.6-4,4-4h24c2.4,0,4,1.6,4,4S128.462,168.262,126.062,168.262z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.662,107.462c-1.2,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-2-1.2-2.8c0-1.2,0.4-2,1.2-2.8c1.6-1.6,4.4-1.6,5.6,0 c0.8,0.8,1.2,1.6,1.2,2.8c0,1.2-0.4,2-1.2,2.8C147.662,106.662,146.462,107.462,145.662,107.462z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.662,127.462c-1.2,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-2-1.2-2.8c0-1.2,0.4-2,1.2-2.8c1.6-1.6,4.4-1.6,5.6,0 c0.8,0.8,1.2,1.6,1.2,2.8c0,1.2-0.4,2-1.2,2.8C147.662,126.662,146.462,127.462,145.662,127.462z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.662,147.462c-1.2,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-2-1.2-2.8c0-1.2,0.4-2,1.2-2.8c1.6-1.6,4.4-1.6,5.6,0 c0.8,0.8,1.2,1.6,1.2,2.8c0,1.2-0.4,2-1.2,2.8C147.662,146.662,146.462,147.462,145.662,147.462z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.662,167.462c-1.2,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-2-1.2-2.8c0-1.2,0.4-2,1.2-2.8c1.6-1.6,4-1.6,5.6,0 c0.8,0.8,1.2,1.6,1.2,2.8c0,1.2-0.4,2-1.2,2.8C147.662,166.662,146.462,167.462,145.662,167.462z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062,64.262h-132c-2.4,0-4-1.6-4-4v-40c0-2.4,1.6-4,4-4h102c2.4,0,4,1.6,4,4s-1.6,4-4,4h-98v32h124v-34c0-2.4,1.6-4,4-4 s4,1.6,4,4v38C404.062,62.662,402.462,64.262,400.062,64.262z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M268.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C272.062,298.662,270.462,300.262,268.062,300.262z M252.062,292.262h12v-12h-12V292.262z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C312.062,298.662,310.462,300.262,308.062,300.262z M292.062,292.262h12v-12h-12V292.262z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M348.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C352.062,298.662,350.462,300.262,348.062,300.262z M332.062,292.262h12v-12h-12V292.262z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M388.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C392.062,298.662,390.462,300.262,388.062,300.262z M372.062,292.262h12v-12h-12V292.262z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M428.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C432.062,298.662,430.462,300.262,428.062,300.262z M412.062,292.262h12v-12h-12V292.262z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C272.062,338.662,270.462,340.262,268.062,340.262z M252.062,332.262h12v-12h-12V332.262z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C312.062,338.662,310.462,340.262,308.062,340.262z M292.062,332.262h12v-12h-12V332.262z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M348.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C352.062,338.662,350.462,340.262,348.062,340.262z M332.062,332.262h12v-12h-12V332.262z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M388.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C392.062,338.662,390.462,340.262,388.062,340.262z M372.062,332.262h12v-12h-12V332.262z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M428.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C432.062,338.662,430.462,340.262,428.062,340.262z M412.062,332.262h12v-12h-12V332.262z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M228.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C232.062,298.662,230.462,300.262,228.062,300.262z M212.062,292.262h12v-12h-12V292.262z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M228.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C232.062,338.662,230.462,340.262,228.062,340.262z M212.062,332.262h12v-12h-12V332.262z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M124.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C128.062,298.662,126.462,300.262,124.062,300.262z M108.062,292.262h12v-12h-12V292.262z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C168.062,298.662,166.462,300.262,164.062,300.262z M148.062,292.262h12v-12h-12V292.262z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M124.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C128.062,338.662,126.462,340.262,124.062,340.262z M108.062,332.262h12v-12h-12V332.262z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M164.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C168.062,338.662,166.462,340.262,164.062,340.262z M148.062,332.262h12v-12h-12V332.262z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M124.062,380.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C128.062,378.662,126.462,380.262,124.062,380.262z M108.062,372.262h12v-12h-12V372.262z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M164.062,380.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C168.062,378.662,166.462,380.262,164.062,380.262z M148.062,372.262h12v-12h-12V372.262z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.062,300.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C88.062,298.662,86.462,300.262,84.062,300.262z M68.062,292.262h12v-12h-12V292.262z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.062,340.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C88.062,338.662,86.462,340.262,84.062,340.262z M68.062,332.262h12v-12h-12V332.262z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M84.062,380.262h-20c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4h20c2.4,0,4,1.6,4,4v20 C88.062,378.662,86.462,380.262,84.062,380.262z M68.062,372.262h12v-12h-12V372.262z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashierMachineGreen);
export default __webpack_public_path__ + "static/media/cashier-machine-green.3eec5b8594ccc989ca77a701f6af3ae7.svg";
export { ForwardRef as ReactComponent };